const notificationStyles = {
  notificationPopover: {
    overflowY: "auto",
  },
  cursor: {
    cursor: "pointer",
  },
  fixedTop: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    zIndex: 999,
    background: "#FFFF",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexXCenter: {
    display: "flex",
    justifyContent: "center",
  },
  btnTransitionRemove: {
    "&:hover": {
      background: "transparent",
    },
  },
  flexSpaceBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  circularProgress: {
    color: "black",
  },
  notificationItem: {
    borderRadius: "10px",
    width: "100%",
  },
  unReadItemColor: {
    background: "#F0FBE3",
  },
  readItemColor: {
    background: "#F9F9F9",
  },
  backgroundTransparent: {
    backgroundColor: "transparent",
  },
};

export default notificationStyles;
